(() => {
  const section = document.querySelector('[data-kl-brand-strip]');
  if (!section) return;

  const track = section.querySelector('[data-kl-brand-track]');
  const previous = section.querySelector('[data-kl-brand-prev]');
  const next = section.querySelector('[data-kl-brand-next]');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let paused = false;
  let timer;

  const distance = () => Math.max(230, Math.round(track.clientWidth * 0.72));
  const move = (direction) => {
    const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
    const atStart = track.scrollLeft <= 8;
    if (direction > 0 && atEnd) track.scrollTo({ left: 0, behavior: reducedMotion ? 'auto' : 'smooth' });
    else if (direction < 0 && atStart) track.scrollTo({ left: track.scrollWidth, behavior: reducedMotion ? 'auto' : 'smooth' });
    else track.scrollBy({ left: distance() * direction, behavior: reducedMotion ? 'auto' : 'smooth' });
  };

  previous?.addEventListener('click', () => move(-1));
  next?.addEventListener('click', () => move(1));
  section.addEventListener('mouseenter', () => { paused = true; });
  section.addEventListener('mouseleave', () => { paused = false; });
  section.addEventListener('focusin', () => { paused = true; });
  section.addEventListener('focusout', () => { paused = false; });
  section.addEventListener('pointerdown', () => { paused = true; }, { passive: true });

  if (!reducedMotion) {
    timer = window.setInterval(() => {
      if (!paused && document.visibilityState === 'visible') move(1);
    }, 4800);
    window.addEventListener('pagehide', () => window.clearInterval(timer), { once: true });
  }
})();
